import { GET_SEARCH_INTENTION } from "../shared/constants";

const initialState = {
	tripType: "",
	from: "",
	to: "",
	outboundDate: "",
	inboundDate: "",
	adults: "",
	children: "",
	infants: "",
	cabin: "",
	searchingFlights: false
};
export const searchParams = (state = initialState, action) => {
	switch (action.type) {
		case GET_SEARCH_INTENTION:
			return {
				...state,
				fetchingFlightsIntention: true,
				params: action.flightSearchParams,
				searchingFlights: true
			};

		default:
			return state;
	}
};
